import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { changeFormField } from 'apps/auth/actions/formAction';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Text } from 'apps/auth/components/common/Text/Text';
import { validationAndUpdateValue } from 'apps/auth/components/form-multi/utils';
import MarketingCommunicationsTermsModal from 'apps/auth/components/registration/modals/MarketingCommunicationsTermsModal';
import { inputPropType } from 'apps/auth/helpers/customPropTypes';

const Placeholder = styled.div`
    margin-left: 16px;
`;
const CheckboxInput = styled.input.attrs({ type: 'checkbox' })`
    opacity: 0;
    position: absolute;
    z-index: -1;
`;
// TODO: legacy outline was grey_40_lc (hover grey_72_lc); --border_primary_main_default is lighter, and there is no hovered border token.
const CheckboxIndicator = styled.span`
    border: 2px solid var(--border_primary_main_default);
    border-radius: 3px;
    display: inline-block;
    height: 20px;
    width: 20px;
    min-width: 20px;
    box-sizing: border-box;
    position: relative;
`;
const CheckboxTickWrap = styled.span`
    position: absolute;
    left: -2px;
    top: -2px;
    display: none;
`;
const CheckboxLabel = styled.label`
    display: inline-flex;
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};

    &:hover {
        ${CheckboxIndicator} {
            border-color: var(--text_secondary_main_default);
        }
        ${CheckboxInput}:checked + ${CheckboxIndicator} {
            background: var(--fill_primary_hovered);
            border-color: var(--fill_primary_hovered);
        }
    }

    ${CheckboxInput}:checked + ${CheckboxIndicator} {
        background: var(--fill_primary_default);
        border-color: var(--fill_primary_default);

        ${CheckboxTickWrap} {
            display: inline-block;
        }
    }

    ${CheckboxInput}[disabled] + ${CheckboxIndicator} {
        border-color: var(--border_primary_main_disabled);
    }

    ${CheckboxInput}[disabled]:checked + ${CheckboxIndicator} {
        background: var(--fill_primary_disabled);
        border-color: transparent;
    }
`;

const ButtonContainer = styled.div`
    margin-top: 8px;
    margin-left: 36px;
`;

const Checkbox = (props) => {
    const handlerChange = (e) => {
        if (!props.noValidation) {
            const formattedValue = props.marketingOptIn ? (e.target.checked ? '1' : '0') : e.target.checked;
            validationAndUpdateValue(props.formName, formattedValue, props.field, props.changeFormField).then(() => {
                if (props.onChangeHandler) {
                    props.onChangeHandler(props.field?.value, props.field?.name);
                }
            });
        }
    };

    const field = props.field;
    return (
        <>
            <CheckboxLabel htmlFor={field?.name} disabled={props.disabled}>
                <CheckboxInput
                    id={field?.name}
                    name={field?.canonicalPath ? field?.canonicalPath : field?.name}
                    type="checkbox"
                    checked={props.marketingOptIn ? field?.value === '1' : !!field?.value}
                    onChange={props.onChange ? props.onChange : handlerChange}
                    disabled={props.disabled}
                />
                <CheckboxIndicator>
                    <CheckboxTickWrap>
                        <Icon name="check" size="20px" color="white" />
                    </CheckboxTickWrap>
                </CheckboxIndicator>
                {field?.placeholder && (
                    <Placeholder>
                        <Text color={props.disabled ? 'lightGray' : 'primary'} size={props.size}>
                            {field?.placeholder}
                        </Text>
                    </Placeholder>
                )}
            </CheckboxLabel>
            {props.checkBoxButtonCaption && field?.showDisclaimer && (
                <ButtonContainer>
                    <Text
                        size="secondary"
                        variant="button"
                        type="button"
                        color="primary"
                        style={{ textDecoration: 'underline' }}
                        onClick={() => {
                            if (field.disclaimer) {
                                props.modalRef.current?.open(<MarketingCommunicationsTermsModal content={field?.disclaimer} modalRef={props.modalRef} />);
                            }
                        }}
                    >
                        {props.checkBoxButtonCaption}
                    </Text>
                </ButtonContainer>
            )}
        </>
    );
};
Checkbox.propTypes = inputPropType(['checkbox']);
Checkbox.propTypes = {
    disabled: PropTypes.bool,
};

export default connect(null, { changeFormField })(Checkbox);
